module.exports = __webpack_public_path__ + "static/media/creator_report_cover.9f52daca.svg";